import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import AppHeader from 'legacy/components/AppHeader'

const AppFrameContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`

const AppFrameInnerContainer = styled.div`
  display: flex;
  max-width: 100%;
  flex-grow: 1;
`

const AppFrameContentContainer = styled.div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  flex-direction: column;
`

const AppFrameHeader = styled(AppHeader)`
  flex: 0 0 auto;
`

const AppFrameSidebar = styled.div`
  display: flex;
  background-color: ${colors.WHITE};
  border-right: 1px solid ${colors.GRAY_93};
`

const AppFrameContentBar = styled.div`
  display: flex;
  width: 100%;
  flex: 0 0 auto;
`

const AppFrameContentBody = styled.div<{ padding?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: auto;
  padding: ${({ padding }) => (padding ? '20px' : '0px')};
`

interface Props extends React.ComponentPropsWithoutRef<typeof AppFrameContainer> {}

const AppFrame: React.FunctionComponent<Props> = ({ children, ...rest }) => {
  const otherChildren: React.ReactElement[] = []
  let header: React.ReactElement | null = null
  let sidebar: React.ReactElement | null = null
  let contentBar: React.ReactElement | null = null
  let contentBody: React.ReactElement | null = null

  React.Children.forEach(children, child => {
    if (!React.isValidElement(child)) {
      return
    }

    switch (child.type) {
      case AppFrameHeader:
        header = child
        break

      case AppFrameSidebar:
        sidebar = child
        break

      case AppFrameContentBar:
        contentBar = child
        break

      case AppFrameContentBody:
        contentBody = child
        break

      default:
        otherChildren.push(child)
    }
  })

  return (
    <AppFrameContainer {...rest}>
      {otherChildren}
      {header}
      <AppFrameInnerContainer>
        {sidebar}
        <AppFrameContentContainer>
          {contentBar}
          {contentBody}
        </AppFrameContentContainer>
      </AppFrameInnerContainer>
    </AppFrameContainer>
  )
}

export default Object.assign(AppFrame, {
  Header: AppFrameHeader,
  Sidebar: AppFrameSidebar,
  ContentBar: AppFrameContentBar,
  ContentBody: AppFrameContentBody,
})
